import React from 'react';
import Slider from './slider/Slider';
import Header1 from '../header/Header1.js';
import ShopByCategory from '../shop/ShopbyCategory.js';
import Review from '../review/Review.js';
import Customize from '../customize/Customize.js';
import './Home.css';

function Home() {
  return(
    <div className='home-container'>
   
    <Slider></Slider>
    <ShopByCategory></ShopByCategory>
    <Customize></Customize>
    <Review></Review>

    </div>
    
  )
}

export default Home; // ✅ Ensure it's a default export
